import { Component, OnInit } from '@angular/core';
import { EquipeService } from 'src/app/shared/api/equipe.service';
import { IFilterComponentConfiguration } from 'src/app/shared/components/filter-component/filter-component.component';
import { equipeResource } from './equipe.resource';

@Component({
    selector: 'app-equipes',
    templateUrl: './equipes.component.html',
    styleUrls: ['./equipes.component.css']
})
export class EquipesComponent implements OnInit {

    equipeResource = equipeResource;

    filterConfiguration!: IFilterComponentConfiguration;

    constructor(public equipeService: EquipeService) { }

    ngOnInit(): void {
        this.configureFilters();
    }

    private configureFilters() {
        this.filterConfiguration = {
            colunas: [
                {
                    field: 'nome',
                    label: 'Nome',
                },
            ],
            tratarValoresFiltrar: ($event: any) => {
                const filtro: any = {};
                if (!$event) return filtro;
                if ($event.nome) filtro['nome'] = $event.nome;

                return filtro;
            }
        };
    }

}
